import React from 'react';
import { ReactComponent as Bin } from '../../../assets/svgs/Delete.svg';
import { ReactComponent as Pen } from '../../../assets/svgs/Edit.svg';

type NotificationProps = {
  rows: NotificationRow[];
  rowValues: (row: NotificationRow) => void;
  setOpenEditModal: (isOpen: boolean) => void;
  setOpenDeleteModal: (isOpen: boolean) => void;
};

const NotificationsTable = ({
  rows,
  rowValues,
  setOpenEditModal,
  setOpenDeleteModal
}: NotificationProps) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toDateString();
  };

  const getTimeSegmentString = (segment: TimeSegment): string => {
    switch (segment) {
      case 'lunchtime' as TimeSegment:
        return 'Lunchtime';
      case 'morning' as TimeSegment:
        return 'Morning';
      case 'evening' as TimeSegment:
        return 'Evening';
      case 'afternoon' as TimeSegment:
        return 'Afternoon';
      default:
        return 'Invalid Segment';
    }
  };

  const getTableRow = () => {
    if (!rows || rows.length === 0) {
      return (
        <tr>
          <td>No</td>
          <td>rows</td>
          <td>yet</td>
        </tr>
      );
    }
    return rows.map(item => {
      return (
        <tr key={item.id} className="border-b border-gray-300">
          <td className="p-2">{item.title}</td>
          <td className="p-2">{item.message}</td>
          <td className="p-2">{getTimeSegmentString(item.time_segment)}</td>
          <td className="p-2">{item.active.toString()}</td>
          <td className="p-2">
            {item.created_at ? formatDate(item.created_at) : 'Not set'}
          </td>
          <td className="p-2">
            {item.updated_at ? formatDate(item.updated_at) : 'Not set'}
          </td>
          <td className="p-2">
            <button
              data-testid="edit"
              onClick={() => {
                rowValues(item);
                setOpenEditModal(true);
              }}>
              <Pen />
            </button>
          </td>
          <td className="p-2">
            <button
              data-testid="delete"
              onClick={() => {
                rowValues(item);
                setOpenDeleteModal(true);
              }}>
              <Bin />
            </button>
          </td>
        </tr>
      );
    });
  };

  return (
    <table className="table w-full border border-gray-300 overflow-auto">
      <thead>
        <tr className="text-left bg-gray-200">
          <th className="p-2">Title</th>
          <th className="p-2">Message</th>
          <th className="p-2">Time Segment</th>
          <th className="p-2">Active</th>
          <th className="p-2">Created</th>
          <th className="p-2">Updated at </th>
          <th className="p-2">Edit</th>
          <th className="p-2">Delete</th>
        </tr>
      </thead>
      <tbody>{getTableRow()}</tbody>
    </table>
  );
};

export default NotificationsTable;